<template>
    <div class="aaaaa" style="height: auto;padding-bottom: 50px;">
        <div class="page-header md-2018121001-xxw">
            <div class="clearfix container">
                <div class="logo-box pull-left">
                    <a class="logo examlogo" href="javascript:;" style="left: 0;top:16px;
                                      font-weight: bold;font-size: 16px;color: #ffffff">职业技能等级培训平台-题库系统</a>
                </div>
                <ul class="nav-xxw pull-left">
                    <li class=""><a class="shouye" href="/">首页</a></li>
                    <li style="cursor: pointer;" :class="testType == 1 ? 'active':''" @click="navigationCut(1)"><a
                            class="examZxks">模拟测试</a></li>
                    <li style="cursor: pointer;" :class="testType == 2 ? 'active':''" @click="navigationCut(2)"><a
                            class="examZxks">顺序练习</a></li>
                    <li style="cursor: pointer;" :class="testType != 1 && testType != 2 ? 'active':''"
                        @click="navigationCut(3)"><a class="examZxks">我的错题本</a></li>
                </ul>
                <div class="pull-right">
                    <a href="/" class="form-btn form-btn-blue from-save" id="out_login"
                        style="background-color: #4fc7ff;border-color: #4fc7ff;color: #ffffff;">退出</a>
                </div>
            </div>
        </div>

        <div class="page-body">
            <div class="container md-2018121102-xxw" style="position: relative;">
                <p class="md-hd bg-fff color-28b2f7 padding-40px">测试列表</p>

                <a v-if="testType == 1" @click="begin(1)" class="form-btn form-btn-blue from-save kscs"
                    style="position: absolute;right: 38px;top: 40px;">开始测试</a>
                <a v-if="testType == 2" @click="begin(2)" class="form-btn form-btn-blue from-save kscs"
                    style="position: absolute;right: 38px;top: 40px;">开始练习</a>

                <div class="curs-x pull-right" v-if="testType!=1&&testType!=2"
                    style="position: absolute; top: 0; right: 10px;">
                    <span @click="simulationTestOrOrderToPractice(1)" :class="testType1 == 1? 'active' : ''"
                        style="font-weight: bold;font-size: 16px;cursor: pointer;">模拟测试</span> |
                    <span @click="simulationTestOrOrderToPractice(2)" :class="testType1 == 2? 'active' : ''"
                        style="font-weight: bold;font-size: 16px;cursor: pointer;">顺序练习</span>
                </div>

                <div class="md-bd bg-fff">
                    <div class="scrach-box clearfix">
                        <div class="form-group clearfix pull-left" v-if="testType==1 || testType==2">
                            <input v-model="val" class="pull-left" type="text" placeholder="输入考试名称">

                            <span @click="select" id="search_btn" class="pull-left"> <i
                                    class="layui-icon layui-icon-search" style="font-size: 27px"></i> </span>
                        </div>

                        <div class="curs-x pull-right" v-if="testType==1 || testType==2">
                            <span style="cursor: pointer;" :class="testState == 1? 'active':''"
                                @click="flag(1)">进行中</span> |
                            <span style="cursor: pointer;" :class="testState == 2? 'active':''"
                                @click="flag(2)">已完成</span>
                        </div>
                    </div>

                    <el-table v-if="testType==1 || testType==2" :data="examlist" style="width: 100%">
                        <!-- 序号 -->
                        <el-table-column align="center" label="序号" width="auto" type="index">
                        </el-table-column>
                        <!-- 考试名称 -->
                        <el-table-column show-overflow-tooltip :label="testType == 1? '测试名称':'练习名称'" width="auto"
                            prop="testName" align="center">
                        </el-table-column>
                        <!-- 测试时间  -->
                        <el-table-column show-overflow-tooltip :label="testType == 1? '测试时间':'练习时间'" width="auto"
                            prop="testDate" align="center">
                        </el-table-column>
                        <!-- 状态 -->
                        <el-table-column label="状态" width="140" align="center">
                            <template slot-scope="scope">
                                <!-- 进行中 -->
                                <span v-if="scope.row.testState == 1" class="ks-typex ks-typex2">进行中</span>

                                <!-- 已结束 -->
                                <span v-if="scope.row.testState == 2" class="ks-typex ks-typex2"
                                    style="background-color: #49af4a">已完成</span>

                            </template>
                        </el-table-column>
                        <!-- 考试时长(分钟) -->
                        <el-table-column v-if="testType == 1" label="测试时长(分钟)" width="auto" prop="testSetTime"
                            align="center">
                        </el-table-column>
                        <!-- 总题量  -->
                        <el-table-column label="总题量" width="auto" prop="testQueNum" align="center">
                        </el-table-column>

                        <!-- 总题量  -->
                        <el-table-column v-if="testType == 2" label="进度" width="auto" prop="testViewNum" align="center">
                        </el-table-column>

                        <!-- 总分  -->
                        <el-table-column v-if="testType == 1" label="总分 width=" auto" prop="testAllScore"
                            align="center">
                        </el-table-column>

                        <!-- 得分  -->
                        <el-table-column v-if="testType == 1" label="得分" width="auto" prop="testScore" align="center">
                        </el-table-column>

                        <el-table-column label="操作" width="auto" align="center">
                            <template slot-scope="scope">
                                <span v-if="testType == 1" @click="ImmediatelyTheTest1(scope.row)"
                                    class="ks-btn ks-btn1">查看试卷</span>
                                <span v-if="testType == 2" @click="ImmediatelyTheTest(scope.row)"
                                    class="ks-btn ks-btn1">继续练习</span>
                            </template>
                        </el-table-column>
                    </el-table>

                    <el-collapse accordion v-if="testType!=1&&testType!=2" @change="handleChange" accordion>
                        <el-collapse-item
                            style="border: 1px solid #ebeced;margin-bottom: 30px;overflow: hidden;border-radius: 8px;"
                            v-for="(item,index) in examSubjectlist" :key="index" :name="index">
                            <template slot="title">
                                <span
                                    style="font-weight: bold;color: #666;margin-left: 15px;font-size: 15px;">{{item.testName}}</span>
                                <span style="color: #666;position: absolute;right: 90px;">{{item.testDate}}</span>
                            </template>
                            <div v-for="(item1,index1) in examSubjectSonlist" :key="index1"
                                class="padding-100 js-single-select test-paper-list">
                                <div style="margin-bottom: 20px;
                                    color: #333;
                                    font-weight: bold;">
                                    <div class="tit" style="display: flex;
                                    align-items: baseline;">
                                        <span>{{item1.queOrder}}、</span>
                                        <div v-html="item1.queQuestion">
                                            <!-- <p>穿管敷设的铝芯绝缘导线的线芯最小截面应为（&nbsp; ）m㎡。</p> -->
                                        </div>
                                        <i class="xxw107-icon"></i>

                                    </div>
                                </div>
                                <!-- 单选题 -->
                                <el-radio-group v-if="item1.queType == '01'" class="bd" v-model="item1.userAnswer"
                                    @change="multipleChoice(item1,index,index1)" :disabled="true">
                                    <div v-for="(item2,index2) in item1.queOptions" :key="index2"
                                        class="form-checkbox form-checkbox-info item-listx">
                                        <el-radio :label="item2.serialNum" style="display: flex;
                                            padding: 10px 40px;
                                            border: 1px solid transparent;">
                                            <div style="display: flex;">{{item2.serialNum}}. <div
                                                    v-html="item2.optionContent"></div>
                                            </div>
                                        </el-radio>
                                    </div>
                                </el-radio-group>
                                <!-- 判断题 -->
                                <el-radio-group @change="judgeChoiceChange(item1,index,index1)"
                                    v-if="item1.queType == '03'" class="bd" v-model="item1.userAnswer" :disabled="true">
                                    <div class="form-checkbox form-checkbox-info item-listx">
                                        <label>
                                            <el-radio label="对">
                                                <div style="display: flex;">对</div>
                                            </el-radio>
                                        </label>
                                    </div>
                                    <div class="form-checkbox form-checkbox-info item-listx">
                                        <label>
                                            <el-radio label="错">
                                                <div style="display: flex;">错</div>
                                            </el-radio>
                                        </label>
                                    </div>
                                </el-radio-group>
                                <!-- 多选题 -->
                                <el-checkbox-group @change="(val)=> multipleChoiceChange(item1,index,index1,val)"
                                    v-if="item1.queType == '02'" class="bd" v-model="item1.userAnswerList"
                                    :disabled="true">
                                    <div v-for="(item2,index2) in item1.queOptions" :key="index2"
                                        class="form-checkbox form-checkbox-info item-listx">
                                        <label>
                                            <el-checkbox :label="item2.serialNum">
                                                <div style="display: flex;">{{item2.serialNum}}. <div
                                                        v-html="item2.optionContent"></div>
                                                </div>
                                            </el-checkbox>
                                        </label>
                                    </div>
                                </el-checkbox-group>


                                <div class="md-footer" style="margin-top: 10px;margin-left: 35px;">
                                    <div class="d1 color-28b2f7">【正确答案】{{item1.queAnswer}}</div>
                                    <div class="d1 color-28b2f7">【答案解析】暂无解析 </div>
                                </div>

                            </div>
                        </el-collapse-item>
                    </el-collapse>

                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[5,10,15]" :page-size="pagesize"
                        layout="total, sizes, prev, pager, next, jumper" :total="total" style="margin-top: 30px;">
                    </el-pagination>
                </div>

            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: 'app',
        components: {

        },
        data() {
            return {
                examSubjectlist: [],
                val: '',
                examlist: [],
                total: 0,   //一共多少条
                pagesize: 5,  //一页几条
                currentPage: 1,//当前页
                longTime: 0,
                testState: 1,
                testType: 1,
                testType1: 1, //错题本
                examSubjectSonlist: []
            }
        },
        created() {
            document.querySelector('body').setAttribute('style', 'background-color:#eff3f7;')
            //加载考试列表
            this.loadExamList(this.currentPage, this.pagesize, '', this.testState, this.testType);
        },
        mounted() {

        },
        beforeDestroy() {

        },
        methods: {
            simulationTestOrOrderToPractice(index) {
                this.testType1 = index;

                this.currentPage = 1;
                this.loadExercisesErrorList(this.currentPage, this.pagesize, this.testType1);
            },
            handleChange(val) {

                if (String(val) != '') {
                    let parames = new URLSearchParams();
                    parames.append('id', this.examSubjectlist[val].id);
                    parames.append('userAnsState', 2);
                    parames.append('userId', this.$storage.get('declareUser').id);

                    let ArrayList = [];
                    this.$axios.post(this.serverUrl + '/ex/selectOneUserExercises', parames).then(resp => {

                            resp.data.data.exercisesAndQueTypes.forEach(function (element, index) {
                                //试题                  

                                element.exercisesUserQuestionVos.forEach(function (element1, index1) {
                                    let enterParameterMultipleChoiceQuestion = element1;
                                    let userAnswerList = [];
                                    //如果是多选题  则创建数组 用户页面回显用
                                    if (element.queType == '02') {
                                        if (element1.userAnswer != null && element1.userAnswer != '') {
                                            userAnswerList = element1.userAnswer.split(",");
                                        }
                                    }
                                    element1.userAnswerList = userAnswerList;

                                    element1.queType = element.queType;

                                    ArrayList.push(element1);
                                })

                            });
                            this.examSubjectSonlist = ArrayList;

                    }).catch(err => {

                    })
                }



            },
            begin(index) {
                console.log(this.$storage.get('declareUser'));

                if(this.$storage.get('declareUser').isExpert == 1){
                    this.$router.push({ path: '/exercisePrepositionExpert/' + index });
                }else{
                    this.$router.push({ path: '/exercisePreposition/' + index });
                }
                

            },
            navigationCut(index) {
                this.testType = index;

                if (this.testType == 1 || this.testType == 2) {
                    //顺序练习/模拟测试
                    this.currentPage = 1;
                    this.loadExamList(this.currentPage, this.pagesize, this.val, this.testState, this.testType);
                } else {
                    console.log("jinlaile");
                    //我的错题本
                    this.currentPage = 1;
                    this.loadExercisesErrorList(this.currentPage, this.pagesize, this.testType1);
                }
            },
            flag(index) {
                this.testState = index;

                this.loadExamList(this.currentPage, this.pagesize, this.val, this.testState, this.testType);
            },
            select() {

                this.loadExamList(1, this.pagesize, this.val, this.testState, this.testType);
            },
            loadExercisesErrorList(page, limit, testType) {

                let parames = new URLSearchParams();
                parames.append('testType', testType);
                parames.append('limit', limit);
                parames.append('page', page);
                parames.append('testState', 2);
                parames.append('userId', this.$storage.get('declareUser').id);

                let ArrayList = [];
                this.$axios.post(this.serverUrl + '/ex/getExercisesErrorList', parames).then(resp => {

                        this.total = resp.data.recordsFiltered;
                        resp.data.data.forEach(function (element, index) {
                            //试题                  
                            let exam = {
                                id: 0,
                                testName: '',
                                testDate: ''
                            }
                            exam.id = element.id;
                            exam.testName = element.testName;
                            exam.testDate = element.testDate;
                            ArrayList.push(exam);
                        });
                        this.examSubjectlist = ArrayList;

                }).catch(err => {

                })

            },
            ImmediatelyTheTest1(row) {
                this.$router.push({ name: 'mockTestTestId', params: { testId: row.id } });
            },
            ImmediatelyTheTest(row) {
                this.$router.push({ name: 'exerciseSequence', params: { testId: row.id, testViewNum: row.testViewNum } });
            },
            //切换每页多少条 触发
            handleSizeChange(val) {
                console.log(`每页dusoaho条`);
                this.pagesize = val;
                this.loadExamList(this.currentPage, this.pagesize, this.val, this.testState, this.testType);
            },
            //第几页切换的时 触发
            handleCurrentChange(val) {
                this.currentPage = val;
                this.loadExamList(this.currentPage, this.pagesize, this.val, this.testState, this.testType);
            },
            getSysTime() {
                return new Promise((resolve, reject) => {
                    this.$axios.post(this.serverUrl + '/serverTime/getServerTime').then(resp => {
                        this.longTime = resp.data.serverTime;
                        resolve();
                    }).catch(err => {
                    })
                });
            },
            loadExamList(page, limit, examName, testState, testType) {
                let parames = new URLSearchParams();
                parames.append('userId',this.$storage.get('declareUser').id);
                parames.append('limit', limit);
                parames.append('page', page);
                parames.append('testType', testType);
                parames.append('testName', examName);
                parames.append('testState', testState);


                let ArrayList = [];
                this.$axios.post(this.serverUrl + '/ex/getExercisesList', parames).then(resp => {
                    
                        this.total = resp.data.recordsFiltered;
                        resp.data.data.forEach(element => {
                            let exam = {
                                id: 0,
                                paperId: 0,
                                testName: '',//考试名称
                                beginTime: '',//考试开始时间
                                endTime: '',//考试结束时间
                                beginLongTime: 0,//考试开始时间时间戳
                                endLongTime: 0,//考试结束时间时间戳
                                testSetTime: 0,//测试规定用时，毫秒
                                testQueNum: 0,//总题量
                                testState: 0,//测试状态 1进行中 2 已结束
                                resultState: 0,////考试结果标识：0：未批阅 1不通过 2通过
                                testDate: '',
                                testViewNum: 0,
                                testAllScore: 0,
                                testScore: 0
                            }

                            exam.id = element.id;
                            exam.paperId = element.paperId;
                            exam.testName = element.testName; //标题
                            exam.beginTime = element.beginTime; //考试开始时间
                            exam.endTime = element.endTime;
                            exam.beginLongTime = new Date(element.beginTime).getTime();
                            exam.endLongTime = new Date(element.endTime).getTime();
                            exam.testSetTime = parseInt(element.testSetTime) / 60000;
                            exam.testQueNum = element.testQueNum;
                            exam.testState = element.testState;
                            exam.resultState = element.resultState;
                            exam.testDate = element.testDate;
                            exam.testAllScore = element.testAllScore;
                            exam.testScore = element.testScore;
                            exam.testViewNum = element.testViewNum;

                            ArrayList.push(exam);
                        });
                        this.examlist = ArrayList;

                }).catch(err => {

                })

            }
        }
    }
</script>

<style scoped>
    .md-2018121002-xxw .hd {
        margin-bottom: 20px;
        color: #333;
        font-weight: bold;
    }

    .md-2018121002-xxw .item-listx label {
        display: block;
        padding: 10px 40px;
        border: 1px solid transparent;
    }

    .md-2018121002-xxw .test-paper-list {
        margin-bottom: 24px;
    }

    .padding-100 {
        padding: 20px 25px 20px;
    }

    .md-2018121102-xxw .curs-x .active {
        color: #28b2f7;
    }

    .form-btn-blue {
        color: #fff;
        background-color: #4b95ff;
        border-color: #4b95ff;
    }

    .md-2018121102-xxw .curs-x .active {
        color: #28b2f7;
    }

    .md-2018121102-xxw .curs-x {
        padding-top: 27px;
    }

    .md-2018121001-xxw .nav-xxw li a {
        display: block;
        color: inherit;
    }

    .md-2018121001-xxw .nav-xxw .active {
        color: #ffcc33;
        font-weight: bold;
    }

    .form-btn {
        display: inline-block;
        padding: 5px 24px 6px;
        margin-bottom: 0;
        font-size: 14px;
        font-weight: normal;
        line-height: 1.42857143;
        text-align: center;
        white-space: nowrap;
        vertical-align: middle;
        -ms-touch-action: manipulation;
        touch-action: manipulation;
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        background-image: none;
        border: 1px solid transparent;
        border-radius: 4px;
        /* height: 32px; */
    }

    .ks-btn {
        display: inline-block;
        line-height: 26px;
        background: #29b2f7;
        color: #fff;
        padding: 2px 8px;
        border-radius: 4px;
        cursor: pointer;
    }

    .layui-bg-gray {
        background-color: #eee !important;
        color: #666 !important;
    }

    .layui-badge {
        height: 18px;
        line-height: 18px;
        position: relative;
        display: inline-block;
        padding: 0 6px;
        font-size: 12px;
        text-align: center;
        color: #fff;
        border-radius: 2px;
    }

    .ks-typex {
        display: inline-block;
        line-height: 26px;
        background: #ec7064;
        color: #fff;
        padding: 0 16px;
        border-radius: 15px;
    }

    .md-2018121102-xxw .form-group span[data-v-6b497b7c] {
        width: 48px;
        height: 50px;
        font-size: 24px;
        background: #bdc3c7;
        text-align: center;
        line-height: 46px;
        color: #fff;
        cursor: pointer;
    }

    .layui-icon-search:before {
        content: "\e615";
    }

    .layui-icon {
        font-family: layui-icon !important;
        font-size: 16px;
        font-style: normal;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    .md-2018121102-xxw .form-group span {
        width: 48px;
        height: 50px;
        font-size: 24px;
        background: #bdc3c7;
        text-align: center;
        line-height: 46px;
        color: #fff;
        cursor: pointer;
    }

    .md-2018121102-xxw .form-group input {
        width: 750px;
        height: 100%;
        padding-left: 10px;
        background: #fdfdfd;
        border: none;
    }

    .md-2018121102-xxw .form-group {
        width: 800px;
        height: 48px;
        border-radius: 4px;
        border: 1px solid #bdc3c7;
        overflow: hidden;
        display: flex;
    }

    .md-2018121102-xxw>.md-bd {
        padding: 30px 40px;
    }

    .color-28b2f7 {
        color: #28b2f7;
    }

    .bg-fff {
        background: #fff;
    }

    .padding-40px {
        padding: 0 40px;
    }

    .md-2018121102-xxw .md-hd {
        line-height: 55px;
        margin: 28px 0;
        border-radius: 8px;
        font-size: 16px;
        font-weight: bold;
    }

    .xxw107-icon {
        background: url(../../../static/img/iconxx0107_03.png) no-repeat;
        display: inline-block;
        padding: 8px;
        position: relative;
        top: 3px;
    }

    .xxw107-icon1 {
        background: url(../../../static/img/iconxx0107_06.png) no-repeat;
        display: inline-block;
        padding: 8px;
        position: relative;
        top: 2px;
        left: -10px;
    }

    .md-2018121002-xxw .hd>.tit {
        display: flex;
        align-items: baseline;
    }

    .other-1221-hd {
        padding: 0 22px;
        line-height: 42px;
        background: #d4f0fd;
        color: #014c85;
        font-size: 22px;
        width: 95%;
        margin: 0 auto;
        margin-bottom: 36px;
    }

    .md-2018121002-xxw .hd>.tit {
        display: flex;
        align-items: baseline;
    }

    .md-2018121002-xxw .hd {
        margin-bottom: 20px;
        color: #333;
        font-weight: bold;
    }

    .aaaaa {
        background: #f3f2f2;
        line-height: 24px;
        font: 14px Helvetica Neue, Helvetica, PingFang SC, Tahoma, Arial, sans-serif;
    }

    .md-2018121001-xxw .nav-xxw li {
        float: left;
        margin-right: 35px;
    }

    .md-2018121001-xxw .nav-xxw .active {
        color: #ffcc33;
        font-weight: bold;
    }

    .md-2018121001-xxw .nav-xxw {
        color: #ffffff;
        margin-left: 68px;
        font-size: 16px;
    }

    a {
        color: #333;
        text-decoration: none;
    }

    .md-2018121001-xxw {
        background: #002856;
        height: 70px;
        line-height: 68px;
    }

    .container {
        clear: both;
        margin: 0 auto;
        text-align: left;
        width: 1200px;
    }

    .pull-left {
        float: left;
    }

    .pull-right {
        float: right;
    }
</style>


// WEBPACK FOOTER //
// src/components/exercise/exerciseHomePage.vue